package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.image.ImageTarget
import fr.manyverse.app.domain.repository.ImageStorageRepository
import fr.manyverse.app.domain.repository.PreMadeCharacterRepository
import fr.manyverse.app.domain.validation.CharacterValidator

class DeletePreMadeCharacterUseCase(
    private val preMadeCharacterRepository: PreMadeCharacterRepository,
    private val imageStorageRepository: ImageStorageRepository
) {
    suspend operator fun invoke(id: String): Result<Unit> {
        CharacterValidator.validateId(id).onFailure { return Result.failure(it) }

        val preMade = preMadeCharacterRepository.getPreMadeCharacterById(id).getOrNull()

        if (preMade?.imageUrl != null) {
            imageStorageRepository.delete(ImageTarget.PreMade(preMade.tableId, id))
        }

        return preMadeCharacterRepository.deletePreMadeCharacter(id)
    }
}
